module.exports = __webpack_public_path__ + "img/couponshow.e3e8b021.png";